import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20background%20with%20soft%20gradients%2C%20dark%20red%20and%20warm%20golden%20tones%2C%20subtle%20film%20grain%20texture%2C%20clean%20minimal%20look%2C%20elegant%20theater%20atmosphere%2C%20bokeh%20lights&width=1920&height=600&seq=cta-cinema-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/90 to-foreground-900/70"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4">
          准备好了吗？开始你的观影之旅
        </h2>
        <p className="text-white/70 text-sm md:text-base mb-8 max-w-xl mx-auto">
          海量高清电影、超清电视剧等你来发现。蓝光1080P画质，高清不卡，流畅不缓冲，即点即看！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/action"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-film-line mr-1"></i>
            浏览电影
          </Link>
          <Link
            to="/category/drama"
            className="px-8 py-3 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white font-semibold rounded-full border border-white/30 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-tv-2-line mr-1"></i>
            浏览电视剧
          </Link>
        </div>
      </div>
    </section>
  );
}